module.exports = __webpack_public_path__ + "static/img/btn3.f018087.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/btn3.png
// module id = NUyS
// module chunks = 1